import {ThemeProvider,Container, Box, Typography,  CardContent, Paper, Button} from '@mui/material';

import theme from "../../theme";
import ImgCarousel from "./Carousel";

import { motion } from 'framer-motion';
import { AnimatePresence } from 'framer-motion';


import { useState } from 'react';

const fadeInVariant = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: 'easeOut' },
  },
};

const fadeVariant = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};



const About = () => {

    // Stan do kontrolowania widoczności tekstu
    const [showMore, setShowMore] = useState(false);

    // Funkcja do zmiany stanu widoczności
    const toggleShowMore = () => {
        setShowMore(prevShowMore => !prevShowMore);
    };

    return(

        <ThemeProvider theme={theme}>

            <motion.div
                variants={fadeInVariant}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }} // 30% widoczne = start animacji
                >


            <Container 
                    // maxWidth="xl"
                       id='about'
                       component={Paper}
                    
                       sx={{
                           paddingTop:'16px',
                            //  marginLeft: {xs:'20px' ,sm:'30px'},
                            //  marginRight:{xs:'20px' ,sm:'30px'},
                            maxWidth:  {xs:'380px' ,sm:'700px', md:'900px',lg:'1200px',xl:'1300px'}
                         
                       }}>

                <Box>
                   
                    <Box maxWidth='md'
                            sx={{
                                margin: '0 auto',
                                marginTop: '20px'
                            }}>
                            <ImgCarousel />
                        </Box>

                       
                       
                        <Typography variant="body2"
                                    sx={{
                                        mr: 3,
                                        display: 'flex',
                                        flexWrap:'wrap',
                                        // ml:{ xs: 5, md: 17, xl:15 },
                                        mt:{ xs: 2, xl:3 },
                                        fontSize: { xs: 12, sm:14 },                       
                                        textAlign:'justify'
                                    }}
                        >
                            Jestem pszczelarzem, który stawia pierwsze kroki w pszczelarstwie. Moja pasieka znajduje się w malowniczej okolicy Łodzi.
                        
                            Pszczoły od zawsze były gdzieś w tle i ich motyw towarzyszył mi w moim życiu. Założenie pasieki było pewnego rodzaju marzeniem do zrealizowania, dlatego gdy tylko pojawiła się możliwość nie zwlekałem i poczyniłem działania, aby rozpocząć pszczelą przygodę.
                        </Typography>

                         {/* Przycisk do pokazania/ukrycia dodatkowego tekstu */}

                 
                        <AnimatePresence>
                        {showMore && (
                            <motion.div
                            key="extraText"
                            variants={fadeVariant}
                            initial="hidden"
                            animate="visible"
                            exit="hidden"
                            >
                            <Typography variant="body2"
                                                            sx={{
                                                                mr: 3,
                                                                display: 'flex',
                                                                flexWrap:'wrap',
                                                                // ml:{ xs: 5, md: 17, xl:15 },
                                                                mt:{ xs: 2, xl:3 },
                                                                fontSize: { xs: 12, sm:14 },                                        
                                                                textAlign:'justify'
                                                            }}
                                                >

                        Jeszcze w styczniu 2022 zapisałem się do Rejonowego Koła Pszczelarskiego nr 2 w Łodzi, a już w marcu uroczyście złożyłem przysięgę pszczelarską. Dzięki książkom, internetowi, ale przede wszystkim dzięki uprzejmości jednego z młodszych wiekiem pszczelarzy byłem uzbrojony w wiedzę i plany. Na początku myślałem o posiadaniu 2 rodzin, jako że dużo słyszałem o chorobach i problemach z zimowaniami dosyć szybko zacząłem rozważać 4 rodziny w razie gdyby jakieś nie przetrwały pod ręką nowicjusza. Gdy telefonicznie rozmawiałem ze sprzedającym bardzo łatwo dałem się namówić finalnie na 8 rodzin pszczelich. Zamieszkały u nas w połowie kwietnia 2022. Był stres... czy nie za dużo, czy dam radę, a co będzie jak to nie będzie dla mnie. Jednak już za pierwszym razem gdy otworzyłem już swoje, przywiezione pszczoły, gdy słyszałem ich brzęczenie i poczułem zapach z ula na nieco dłużej niż kilka chwil wiedziałem, że to był dobry wybór. Bardzo szybko wsiąkłem w to hobby. Oczekiwałem z utęsknieniem każdego weekendu i dobrej pogody by się im przyjrzeć i z nimi popracować.

                                                </Typography>

                                                <Typography variant="body2"
                                                            sx={{
                                                                mr: 3,
                                                                display: 'flex',
                                                                flexWrap:'wrap',
                                                                // ml:{ xs: 5, md: 17, xl:15 },
                                                                mt:{ xs: 2, xl:3 },
                                                                fontSize: { xs: 12, sm:14 },                                        
                                                                textAlign:'justify'
                                                            }}
                                                >

                        Pierwsze miodobranie było niesamowitym przeżyciem. Zapach uli, świeżego miodu, ale przede wszystkim satysfakcja z tego, że praca pszczół i jak i moja przynosi zadowalające efekty. I na dodatek pyszne, prawdziwe, słodkie efekty.

                                                </Typography>

                                                <Typography variant="body2"
                                                            sx={{
                                                                mr: 3,
                                                                display: 'flex',
                                                                flexWrap:'wrap',
                                                                // ml:{ xs: 5, md: 17, xl:15 },
                                                                mt:{ xs: 2, xl:3 },
                                                                fontSize: { xs: 12, sm:14 },                                        
                                                                textAlign:'justify'
                                                            }}
                                                >


                        Miód z naszej pasieki, ze względu na swoją dobrą jakość szybko zyskał swoją rzeszę fanów. Nie powiem, spodobało mi się to uczucie... no cóż, niektórzy zbierają lajki, a ja wolę zbierać klientów, którzy cieszą się smakiem prawdziwego miodu prosto z pasieki.


                                                </Typography>

                                                <Typography variant="body2"
                                                            sx={{
                                                                mr: 3,
                                                                display: 'flex',
                                                                flexWrap:'wrap',
                                                                // ml:{ xs: 5, md: 17, xl:15 },
                                                                mt:{ xs: 2, xl:3 },
                                                                fontSize: { xs: 12, sm:14 },
                                                                textAlign:'justify'
                                                            }}
                                                >

                        W związku z tym rozwój pasieki zaczął nabierać sensu. Zacząłem więcej czytać, planować, i prowadzić notatki. Rozmnażałem moje rodziny jak i nie stroniłem od okazyjnych zakupów. Dzięki temu pasieka na koniec sezonu 2022 liczyła już 22 pni.

                                                </Typography>

                                                <Typography variant="body2"
                                                            sx={{
                                                                mr: 3,
                                                                display: 'flex',
                                                                flexWrap:'wrap',
                                                                // ml:{ xs: 5, md: 17, xl:15 },
                                                                mt:{ xs: 2, xl:3 },
                                                                fontSize: { xs: 12, sm:14 },                                        
                                                                textAlign:'justify'
                                                            }}
                                                >

                        Nie wiem z iloma skończę, gdyż dalej jest to tylko hobby poza moją normalną pracą na etacie. Czas i pogoda niejednokrotnie stawiają przede mną wyzwania, że nie wspomnę o logistyce. No tak... zapomniałem dodać, że uprzejmy kolega pszczelarz namówił mnie na pasiekę wędrowną, ale o tym i wiele innym możecie dowiedzieć się sprawdzając nasz instagram lub facebook.

                                                </Typography>

                                                <Typography variant="body2"
                                                            sx={{
                                                                mr: 3,
                                                                display: 'flex',
                                                                flexWrap:'wrap',
                                                                // ml:{ xs: 5, md: 17, xl:15 },
                                                                mt:{ xs: 2, xl:3 },
                                                                fontSize: { xs: 12, sm:14 },
                                                                textAlign:'justify'
                                                            }}
                                                >

                        Pasieka jest pod nadzorem weterynaryjnym, a miód pszczeli sprzedaję legalnie w ramach rolniczego handlu detalicznego pod numerem 10613529, który uzyskałem w maju 2022 roku.

                                                </Typography>
                            </motion.div>
                        )}
                        </AnimatePresence>


                        <div style={{ display: 'flex', justifyContent: 'center' }}>

                        <Button variant='contained'
                            color='secondary'                        
                            // fullWidth
                            onClick={toggleShowMore}
                            sx ={{marginTop:'20px',
                                marginBottom: '30px',
                                width:'30%',
                                fontSize: { xs: 12, sm:16 },                           
                        }}>
                             {showMore ? 'Pokaż mniej' : 'Dowiedz się więcej'}
                        </Button>

                        </div>
                   
                </Box>

            </Container >
            </motion.div>
        </ThemeProvider >
    )
}

export default About;